import { ListScreen, StackScreenProps } from '@rahtab/stack-navigator';
import { DatePicker, ListEmpty } from '@rahtab/ui';
import LoadItemCard from 'components/LoadItemCard';
import { RootStackType } from 'components/Router';
import useVetApproveHistory, { LoadStatusCode } from 'hooks/useVetApproveHistory';
import moment from 'moment-jalaali';
import React, { useEffect, useState, VFC } from 'react';

const DATE_FORMAT = 'YYYY/MM/DD';
const DISPLAY_DATE_FORMAT = 'jYYYY/jMM/jDD';

type VerifiedLoadsHistoryProps = StackScreenProps<RootStackType, 'VerifiedLoadsHistory'>;

const VerifiedLoadsHistory: VFC<VerifiedLoadsHistoryProps> = ({ route, navigation }) => {
  const now = moment();
  const { refetch: shouldRefetch } = route.params || {};
  const [requestDate, setRequestDate] = useState(now.format(DATE_FORMAT));
  const {
    refetch,
    result: { called, loading, data },
  } = useVetApproveHistory({ requestDate });

  useEffect(() => {
    if (shouldRefetch) {
      if (called) refetch();
      navigation.setParams({ refetch: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRefetch]);

  return (
    <ListScreen
      title="سوابق بارها"
      data={data}
      loading={!called && loading}
      keyboardShouldPersistTaps="handled"
      refreshing={called && loading}
      onRefresh={refetch}
      renderControls={() => {
        return (
          <DatePicker
            placeholder="تاریخ گزارش را انتخاب نمایید."
            label="تاریخ گزارش"
            value={requestDate}
            onConfirm={setRequestDate}
            format={DATE_FORMAT}
            displayFormat={DISPLAY_DATE_FORMAT}
            margin="none"
            sameOrBefore={now.toDate()}
          />
        );
      }}
      listData={data}
      keyExtractor={(item, index) => item.reqIdentification || (Date.now() + index).toString()}
      ListEmptyComponent={<ListEmpty text="هیچ سابقه‌ای یافت نشد." />}
      renderItem={({ item }) => {
        const isPending = item.StatusCode === LoadStatusCode.Pending;

        const screenName = isPending ? 'SubmitLoadInfo' : 'VerifiedLoadInfo';

        return (
          <LoadItemCard
            {...item}
            screenName={screenName}
            params={isPending ? { RequestId: item.reqIdentification, fromHistory: true } : (item as any)}
          />
        );
      }}
    />
  );
};

export default VerifiedLoadsHistory;
